import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { Logo } from '../components/Logo.js'
import { Button, ErrorNotice, Field, Input } from '../components/ui.js'
import { api } from '../lib/api.js'
import { useT } from '../lib/i18n.js'

export function LoginPage() {
  const t = useT()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const login = useMutation({
    mutationFn: () => api.login(email, password),
    async onSuccess(result) {
      queryClient.setQueryData(['me'], result)
      await navigate('/trips')
    },
  })

  function submit(event: FormEvent) {
    event.preventDefault()
    login.mutate()
  }

  return (
    <main className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center gap-6 p-6">
      {/*
        The mark and the agency name, above the form. This is the one screen
        that is nothing but a login, so it is the one screen with room to say
        whose product this is before asking for a password.
      */}
      <div className="flex flex-col items-center gap-3 text-center">
        <Logo variant="full" />
        <p className="font-display text-xl font-semibold tracking-tight">Longhi Travel</p>
      </div>
      <h1 className="text-2xl font-semibold">{t('login.title')}</h1>
      <form onSubmit={submit} className="flex flex-col gap-4">
        <Field label={t('login.email')}>
          <Input
            type="email"
            name="email"
            value={email}
            autoComplete="username"
            required
            onChange={(e) => setEmail(e.target.value)}
          />
        </Field>
        <Field label={t('login.password')}>
          <Input
            type="password"
            name="password"
            value={password}
            autoComplete="current-password"
            required
            onChange={(e) => setPassword(e.target.value)}
          />
        </Field>
        {login.isError && <ErrorNotice error={login.error} />}
        <Button type="submit" disabled={login.isPending}>
          {login.isPending ? t('common.loading') : t('login.submit')}
        </Button>
      </form>
    </main>
  )
}
